import React ,{ useEffect, useState} from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { useNavigate, Link } from "react-router-dom";
import { stringify } from "querystring";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from 'react-helmet';
import './payment_confirmation.css';

type SeoContent = {
  meta_title: string;
  meta_description?: string;
  // Add more fields as needed
};

const PaymentConfirmation: React.FC = () => {

    const dispatch = useDispatch<any>();
    const [soeContent, setSoeContent] = useState<SeoContent | null>(null);

  return (
    <>
    <Helmet>
      <title>{`${soeContent?.meta_title || 'Order Confirmation'}`}</title>
      <meta name="title" content={soeContent?.meta_title || 'E-learning Platform'} />
      <meta name="description" content={soeContent?.meta_description || 'Learn with curated e-learning resources'} />
      <meta name="keywords" content="e-learning, tech-cards, cheat-sheets, tutorials" />
    </Helmet>

      <Header />

      <div className="success-wrapper">
        <div className="success-card">
          <div className="success-header">
            <div className="success-icon">
              <i className="bi bi-check-lg"></i>
            </div>
            <h2 className="fw-bold mb-2">Payment Successful!</h2>
            <p className="mb-0">Thank you for your purchase</p>
          </div>
          
          <div className="success-body">
            <h4 className="fw-bold mb-3">Your transaction was completed successfully</h4>
            <p className="text-muted mb-4">You will receive a confirmation email with your order details shortly.</p>
            
            <div className="info-box">
              <i className="bi bi-info-circle text-primary mb-2" style={{fontSize: '24px'}}></i>
              <p className="mb-0">For detailed order information, visit your orders page</p>
            </div>

            <div className="mt-4">
              <Link to="/my-orders" style={{"width":"50%"}} className="btn btn-primary"><i className="bi bi-list-check me-2"></i>View My Orders</Link>
              <Link to="/" className="btn btn-outline-primary"><i className="bi bi-house me-2"></i>Back to Home</Link>
            </div>

            <div className="text-center mt-5 pt-3">
              <p className="text-muted ">Need help? Contact our support team</p>
              <div>
                <a href="mailto:support@uplatz.com" className="text-decoration-none text-primary me-3">
                  <i className="bi bi-envelope me-1"></i>support@uplatz.com
                </a>
                  <a href="tel:+44 7459 302492" className="text-decoration-none text-primary">
                    <i className="bi bi-telephone me-1"></i> +44 7459 302492
                  </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PaymentConfirmation;
